import { api } from 'app/config/apiConfig';
import { ChangeSizeCodesPricesData, SizeCode } from '../model/types';

export const changeSizeCodesPricesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    changeSizeCodesPrices: builder.mutation<SizeCode[], ChangeSizeCodesPricesData>({
      query: (body) => ({
        url: '/size-codes/change-prices',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Size codes', 'Available sizeCodes', 'Boxes'],
    }),
  }),
});

export const { useChangeSizeCodesPricesMutation } = changeSizeCodesPricesApi;
